import React from "react";
import { motion } from "framer-motion";

// ImagePlate — full-bleed grayscale photographic moment between text sections.
// Filter always applies grayscale + slight contrast for safety even if source is colored.
// Pass `src`, `alt`, `caption`, optional `tag` and `height`.
export default function ImagePlate({
  src,
  alt,
  caption,
  tag,
  height = 520,
  testid,
}) {
  return (
    <section
      className="image-plate border-t hair border-b hair relative"
      data-testid={testid || "image-plate"}
    >
      <div className="image-plate-wrap" style={{ height }}>
        <motion.img
          src={src}
          alt={alt}
          loading="lazy"
          initial={{ opacity: 0, scale: 1.05 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 1.6, ease: [0.16, 1, 0.3, 1] }}
          className="image-plate-img"
        />
        <div className="image-plate-meta pointer-events-none">
          {tag && (
            <span className="mono" style={{ color: "rgba(239,235,227,0.85)" }}>
              {tag}
            </span>
          )}
          {caption && (
            <span className="mono" style={{ color: "rgba(239,235,227,0.7)" }}>
              {caption}
            </span>
          )}
        </div>
      </div>
    </section>
  );
}
